module.exports = __webpack_public_path__ + "static/media/home-white.f3d239b7.svg";